export default __webpack_public_path__ + "static/yoga-2-986cb1cd630d31ec514589af4dd8a299.png";